module.exports = __webpack_public_path__ + "static/media/087-padlock.857ce7fa.svg";